import styles from './ContactInfo.module.scss'
import React from 'react'
import PhoneIcon from '@/assets/svg/phone.svg'
import SendIcon from '@/assets/svg/send.svg'

type Props = {}

const ContactInfo = (props: Props) => {
  return (
    <div className='row'>
      <div className='col-xs-12 col-md-6 flex align-center'>
        <PhoneIcon className={styles.icon} />
        <a href="tel:+46852705264">+46 (0)8 527 052 64</a>
      </div>
      <div className='col-xs-12 col-md-6 flex align-center'>
        <SendIcon className={styles.icon} />
        <a href="mailto:info@statusfalgar.se">info@statusfalgar.se</a>
      </div>
    </div>
  )
}

export default ContactInfo